"use strict";
import { usePermissions } from "./usePermissions";
export function useLoosePermissionCheck(permissions) {
  const [shellPermissions] = usePermissions();
  const shellPermissionsSet = new Set(shellPermissions);
  for (const permission of permissions) {
    if (shellPermissionsSet.has(permission)) return true;
  }
  return false;
}
